export const ANALOGY_CONTEXTUALIZER_PAGE_REFERENCE =
  'What should the analogy be based upon?';
export const ANALOGY_CONTEXTUALIZER_PAGE_TITLE = 'Analogy Page';
export const ANALOGY_DESCRIPTION = `Unlock the powerful tool of analogies. With Analogy, easily create personalized comparisons to simplify complex concepts, providing clarity and understanding for your students.`;
